// src/ErrorPage.js
import React from "react";
import { useRouteError, useNavigate } from "react-router-dom";
import "./error-page.css";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <h1>🚧 Oops! Something went wrong.</h1>
      <p>We're sorry, an unexpected error has occurred.</p>
      <button onClick={() => navigate("/")}>🏠 Go to Homepage</button>

      {process.env.NODE_ENV === "development" && <pre className="error-details">{error?.message}</pre>}
    </div>
  );
}
